import React, { useState } from "react";

import { Dropdown, DropdownMenu, DropdownToggle, Badge } from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";

import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

const BadgesEllipsis = ({ objItems, isHoliday, t }) => {
  const [modal, setModal] = useState(false);
  const showItens = 0;

  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const toggleModal = () => {
    setModal(!modal);
  };

  return (
    <React.Fragment>
      <div>
        {objItems.length > showItens ? (
          <div className="d-flex">
            {isHoliday
              ? objItems.slice(0, showItens).map((holiday, key) => (
                  <Badge
                    key={key}
                    className={"font-size-12 badge-soft-success mr-2"}
                    color="light"
                  >
                    {("0" + holiday.day).slice(-2)}/
                    {("0" + holiday.month).slice(-2)}/{holiday.year}{" "}
                    {("0" + holiday.hour_start).slice(-2)}:
                    {("0" + holiday.minute_start).slice(-2)} -{" "}
                    {("0" + holiday.hour_end).slice(-2)}:
                    {("0" + holiday.minute_end).slice(-2)}
                  </Badge>
                ))
              : objItems.slice(0, showItens).map((schedule, key) => (
                  <Badge
                    key={key}
                    className={"font-size-12 badge-soft-success mr-2"}
                    color="light"
                  >
                    {t(days[schedule.week_day])}{" "}
                    {("0" + schedule.hour_start).slice(-2)}:
                    {("0" + schedule.minute_start).slice(-2)} -{" "}
                    {("0" + schedule.hour_end).slice(-2)}:
                    {("0" + schedule.minute_end).slice(-2)}
                  </Badge>
                ))}
            <Dropdown
              className="d-inline-flex"
              // onClick={() => toggleModal()}
              onMouseEnter={() => toggleModal()}
              onMouseLeave={() => toggleModal()}
              isOpen={modal}
              nav={false}
              a11y={false}
            >
              <div className="d-inline-flex overflow-auto">
                <DropdownToggle
                  tag="span"
                  className="badge-ellipsis font-size-12 mr-2 badge badge-soft-success"
                >
                  +{objItems.length - showItens}
                </DropdownToggle>
              </div>
              <DropdownMenu>
                <PerfectScrollbar
                  className="overflow-hidden"
                  style={{ maxHeight: "30vh" }}
                >
                  {isHoliday
                    ? objItems
                        .slice(showItens, objItems.length)
                        .map((holiday, key) => (
                          <div key={key} className="overflow-auto d-flex">
                            <Badge
                              key={key}
                              className={
                                "font-size-12 badge-ellipsis font-size-12 mx-2 my-1 badge badge-soft-success mr-2 w-100"
                              }
                              color="light"
                            >
                              <div>
                                {("0" + holiday.day).slice(-2)}/
                                {("0" + holiday.month).slice(-2)}/{holiday.year}{" "}
                              </div>
                              <div>
                                {("0" + holiday.hour_start).slice(-2)}:
                                {("0" + holiday.minute_start).slice(-2)} -{" "}
                                {("0" + holiday.hour_end).slice(-2)}:
                                {("0" + holiday.minute_end).slice(-2)}
                              </div>
                            </Badge>
                          </div>
                        ))
                    : objItems
                        .slice(showItens, objItems.length)
                        .map((schedule, key) => (
                          <div key={key} className="overflow-auto d-flex">
                            <Badge
                              key={key}
                              className={
                                "font-size-12 badge-ellipsis font-size-12 mx-2 my-1 badge badge-soft-success mr-2 w-100"
                              }
                              color="light"
                            >
                              <div>{t(days[schedule.week_day])} </div>
                              <div>
                                {("0" + schedule.hour_start).slice(-2)}:
                                {("0" + schedule.minute_start).slice(-2)} -{" "}
                                {("0" + schedule.hour_end).slice(-2)}:
                                {("0" + schedule.minute_end).slice(-2)}
                              </div>
                            </Badge>
                          </div>
                        ))}
                </PerfectScrollbar>
              </DropdownMenu>
            </Dropdown>
          </div>
        ) : (
          <div className="d-flex">
            {isHoliday
              ? objItems.map((holiday, key) => (
                  <div key={key} className="overflow-auto d-inline-flex">
                    <span className="badge-ellipsis font-size-12 mr-2 badge badge-soft-success">
                      {("0" + holiday.day).slice(-2)}/
                      {("0" + holiday.month).slice(-2)}/{holiday.year}{" "}
                      {("0" + holiday.hour_start).slice(-2)}:
                      {("0" + holiday.minute_start).slice(-2)} -{" "}
                      {("0" + holiday.hour_end).slice(-2)}:
                      {("0" + holiday.minute_end).slice(-2)}
                    </span>
                  </div>
                ))
              : objItems.map((schedule, key) => (
                  <div key={key} className="overflow-auto d-inline-flex">
                    <span className="badge-ellipsis font-size-12 mr-2 badge badge-soft-success">
                      {t(days[schedule.week_day])}{" "}
                      {("0" + schedule.hour_start).slice(-2)}:
                      {("0" + schedule.minute_start).slice(-2)} -{" "}
                      {("0" + schedule.hour_end).slice(-2)}:
                      {("0" + schedule.minute_end).slice(-2)}
                    </span>
                  </div>
                ))}
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(BadgesEllipsis);
